import dayjs from "dayjs";

/**
 * Earliest bookable check-in date for the guest booking flow.
 *
 * Roatel's Apaleo night audit runs at MIX_BOOKING_CUTOFF_HOUR (default 05:00)
 * Europe/Berlin. Until then the current *business day* is still open, so a
 * late-night walk-in must be able to book the previous calendar date. Between
 * 00:00 and the cutoff hour we therefore step the floor back one day.
 *
 * The cutoff timezone/hour come from build-time env (with Berlin/5 fallbacks) so
 * the frontend and the backend (config/roatel.php reads the same keys) agree.
 *
 * dayjs' utc/timezone plugins and the Europe/Berlin default are configured in
 * resources/js/guest.js at boot, so the imported singleton has `.tz()` available.
 *
 * @returns {Date} local-midnight Date of the earliest bookable calendar day.
 */
export function earliestBookableCheckIn() {
    const tz = process.env.MIX_BOOKING_CUTOFF_TZ || "Europe/Berlin";
    const cutoffHour = parseInt(process.env.MIX_BOOKING_CUTOFF_HOUR ?? "5", 10);

    const now = dayjs().tz(tz);
    const businessDay = now.hour() < cutoffHour ? now.subtract(1, "day") : now;

    // v-calendar compares dates in the browser's local zone, so rebuild the
    // business CALENDAR day (Y-M-D) as a local-midnight Date rather than passing
    // a Berlin instant (which could land on a different local calendar day).
    return dayjs()
        .year(businessDay.year())
        .month(businessDay.month())
        .date(businessDay.date())
        .startOf("day")
        .toDate();
}
